import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { C } from "../constants/theme";
import { Btn } from "../components/ui/Btn";

function ConfirmModal({ mensagem, onConfirm, onCancel }) {
  const panel = useRef(null), cancelAction = useRef(onCancel);
  cancelAction.current = onCancel;
  useEffect(() => {
    const previous = document.activeElement;
    panel.current?.querySelector('button:last-child')?.focus();
    const keydown = event => {
      if (event.key === "Escape") { event.preventDefault(); cancelAction.current(); }
      if (event.key === "Tab") {
        const buttons = panel.current.querySelectorAll('button');
        if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons[buttons.length-1]?.focus(); }
        else if (!event.shiftKey && document.activeElement === buttons[buttons.length-1]) { event.preventDefault(); buttons[0]?.focus(); }
      }
    };
    window.addEventListener('keydown', keydown);
    return () => { window.removeEventListener('keydown', keydown); if (previous?.isConnected) previous.focus(); };
  }, []);
  return createPortal(
    <div style={{ position:"fixed", inset:0, background:"#00000099", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div ref={panel} role="alertdialog" aria-modal="true" aria-label={mensagem} style={{ background:C.panel, border:"1px solid "+C.border, borderRadius:18, padding:24, maxWidth:380, width:"90%", boxSizing:"border-box", maxHeight:"90dvh", overflowY:"auto", textAlign:"center" }}>
        <div style={{ fontSize:36, marginBottom:12 }}>⚠️</div>
        <div style={{ color:C.text, fontSize:15, marginBottom:24, whiteSpace:"pre-line" }}>{mensagem}</div>
        <div style={{ display:"flex", gap:10, justifyContent:"center", flexWrap:"wrap" }}>
          <Btn danger onClick={onConfirm}>Sim, confirmar</Btn>
          <Btn outline onClick={onCancel}>Cancelar</Btn>
        </div>
      </div>
    </div>, document.body
  );
}

export function useConfirm() {
  const [state, setState] = useState(null);
  const confirmar = (msg) => new Promise(resolve => setState({ msg, resolve }));
  const modal = state ? <ConfirmModal mensagem={state.msg} onConfirm={()=>{ state.resolve(true); setState(null); }} onCancel={()=>{ state.resolve(false); setState(null); }} /> : null;
  return [confirmar, modal];
}
